var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46 4046.5c0-3.033 2.467-5.5 5.5-5.5 2.134 0 3.984 1.225 4.896 3.006-.534.007-1.055.071-1.556.185-2.808.635-5.014 2.841-5.649 5.649.549.381 1.201.614 1.901.685.405-2.251 2.182-4.028 4.433-4.433.317-.057.642-.092.975-.092.162 0 .319.02.477.036.012.153.023.307.023.464 0 3.033-2.467 5.5-5.5 5.5s-5.5-2.467-5.5-5.5m14.379-1.41c.072.46.121.929.121 1.41 0 .39-.033.771-.081 1.147.976.994 1.581 2.353 1.581 3.853 0 3.033-2.467 5.5-5.5 5.5-1.5 0-2.859-.605-3.853-1.581-.419-.412-.763-.897-1.034-1.425 4.09-.061 7.387-3.39 7.387-7.494 0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5c0 3.391 2.252 6.254 5.341 7.181.182.6.43 1.172.749 1.698 1.315 2.168 3.689 3.621 6.41 3.621 4.142 0 7.5-3.358 7.5-7.5 0-2.721-1.453-5.095-3.621-6.41",
    fillRule: "evenodd",
    transform: "translate(-44 -4039)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.71077dd917941504c9110a8ffabea6bc.svg";
export { ForwardRef as ReactComponent };